import Joi from 'joi';
import { formatErrorMessage } from 'validation/commonValidators';
import { IBANvalidationSchema } from '../../../Onboarding/helpers';
import { TransferFieldNames, CommunicationTypes } from '../../helpers';
import { structuredCommunicationPatternWithPlus } from 'utils/constants';

export const externalTransferSchema = (sourceAccountBalance?: number) =>
  Joi.object({
    [TransferFieldNames.recipient_name]: Joi.string()
      .required()
      .messages(
        formatErrorMessage(
          'accountable_banking',
          TransferFieldNames.recipient_name,
        ),
      ),
    [TransferFieldNames.recipient_iban]: IBANvalidationSchema,
    [TransferFieldNames.amount]: Joi.number()
      .min(1)
      .custom((value, helpers) => {
        if (sourceAccountBalance != null && value > sourceAccountBalance) {
          return helpers.error('number.max');
        }
        return value;
      })
      .required()
      .messages(
        formatErrorMessage('accountable_banking', TransferFieldNames.amount),
      ),
    [TransferFieldNames.communication]: Joi.when(
      TransferFieldNames.communication_type,
      {
        is: CommunicationTypes.structured,
        then: Joi.string().pattern(structuredCommunicationPatternWithPlus),
      },
    )
      .allow('', null)
      .messages(
        formatErrorMessage(
          'accountable_banking',
          TransferFieldNames.communication,
        ),
      ),
    [TransferFieldNames.firstExecutionDate]: Joi.date().required(),
    [TransferFieldNames.period]: Joi.string().required(),
    [TransferFieldNames.lastExecutionDate]: Joi.optional(),
  });
